module.exports = __webpack_public_path__ + "images/areamap/map_pc_ff664e465a4ccc55850a9558c93309fe.jpg";